/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import { CustomScope } from '../types/initiative';
import { Group, RequiredTags } from '@g17eco/core';

export const hasRequiredTags = (groupRequiredTags: string[] | undefined): groupRequiredTags is string[] => {
  return Boolean(groupRequiredTags && groupRequiredTags.length > 0);
};

/** Need to provide an override for tags that does not match scope_${type} pattern */
const requireTagsMapping: Record<string, string | undefined> = {
  [RequiredTags.DJSI]: 'sam_csa',
  [RequiredTags.VigeoEiris]: 'vigeo_eiris',
}

const requiredTagToScope = (tag: string) => requireTagsMapping[tag] ?? tag.replace('scope_', '');


// Need to translate scope tags to scope
const convertRequiredTagsToScope = (requiredTags: string[]) => requiredTags.map(t => requiredTagToScope(t));

/**
 * Can access Scope if at least one required tag is available in scopeConfig
 */
export const canAccessCustomScopeGroup = (requiredTags: string[] | undefined, scopeConfig: CustomScope[] | undefined) => {
  if (!hasRequiredTags(requiredTags)) {
    return true;
  }

  if (!scopeConfig) {
    return false;
  }
  return convertRequiredTagsToScope(requiredTags)
    // at least one tag is included, NOT all of them
    .some(code => scopeConfig.some(customScope => customScope.code === code))
};

export const isGroupEnabled = (group: Group | undefined, scopeConfig: CustomScope[] | undefined) => {
  if (!group || !hasRequiredTags(group.requiredTags)) {
    return true;
  }
  return canAccessCustomScopeGroup(group.requiredTags, scopeConfig)
}

export enum GroupMessage {
  Disabled = 'To access this survey pack, please contact your organisation\'s administrator and request them to purchase this pack for the organisation.',
}
